import * as MUI from "@mui/material";

type InputBikeProps = {
  nome: string;
  placa: string;
  chassi: string;
  onClick: () => void;
};

export const ResultadoConsultaVeiculoPlaca: React.FC<InputBikeProps> = ({
  nome,
  placa,
  chassi,
  onClick,
}) => {
  return (
    <MUI.Card
      onClick={onClick}
      elevation={5}
      sx={{
        display: "flex",
        mb: 2,
      }}
    >
      <MUI.CardActionArea>
        <MUI.Stack
          display="flex"
          width="100%"
          flexDirection={["column", "row"]}
          p={0.5}
          gap={[0, 2]}
        >
          <MUI.Stack>
            <MUI.Divider
              orientation="vertical"
              sx={{
                borderWidth: 3.2,
                backgroundColor: "orange",
              }}
            />
          </MUI.Stack>
          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Proprietário:
            </MUI.Typography>
            <MUI.Typography variant="caption">{nome}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Placa:
            </MUI.Typography>
            <MUI.Typography variant="caption">{placa}</MUI.Typography>
          </MUI.Stack>

          <MUI.Stack flex={1}>
            <MUI.Typography variant="body2" fontWeight="bold">
              Chassi:
            </MUI.Typography>
            <MUI.Typography variant="caption">{chassi}</MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </MUI.CardActionArea>
    </MUI.Card>
  );
};
